export default __webpack_public_path__ + "static/media/x-icon.a32c4d94.jpg";